import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  name: 'plan-and-consumption',
  namespaced: true,
  state,
  actions,
  mutations,
};
